import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface LoungeBottomSheetProps {}

const LoungeBottomSheet: FC<LoungeBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  const messages = [
    `국내 공항 라운지 무료 이용(월 1회, 연 2회 한도)`,
    `직전 3개월 간 NOL · NOL 인터파크(NOL 인터파크투어/NOL 티켓)·트리플 내 해외 여행상품 100만원 이상 이용 시 제공`,
    `국내외겸용카드를 보유한 본인 회원에 한해, 무료 입장 가능`,
    `서비스 이용 시 NOL 카드 실물 카드 제시 필요`,
    `서비스 이용 전 대상 공항(인천/김포) 및 대상 라운지 위치, 영업 시간 확인 후 이용`,
    `NOL ∙ NOL 인터파크(NOL 인터파크 투어/NOL 티켓) ∙ 트리플 가맹점 및 자체 간편결제 서비스(NOL카드 페이 또는 인터파크 페이)가 아닌 간편결제 서비스명(네이버페이 등) 또는 별도 가맹점번호로 결제되는 경우 실적 제외\n예시) NOL에서 결제했으나 가맹점명이 '네이버 파이낸셜'인 경우`,
    `해당 서비스는 Visa및 Amex에서 제공하는 선택제공 서비스로 이용 관련 자세한 내용은 해당 브랜드사 및 현대카드 홈페이지 참조
      ∙ Visa 홈페이지 : www.visakorea.com
      ∙ Amex 홈페이지 : www.americanexpress.com/kr
      ∙ 현대카드 홈페이지 : www.hyundaicard.com`,
  ].filter(Boolean);

  return (
    <NolNoticeBottomSheet
      title={'공항 라운지 유의사항'}
      isOpen={store.isLoungeBottomSheetOpen}
      onRequestClose={() => (store.isLoungeBottomSheetOpen = false)}
    >
      <ul>
        {messages.map((line, key) => (
          <li key={key} style={{ whiteSpace: 'pre-line' }}>
            {line}
          </li>
        ))}
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(LoungeBottomSheet);
